import PropTypes from 'prop-types';
import React from 'react';
import { css } from '@emotion/core';
import { graphql } from 'gatsby';
import Layout from '../../organisms/Layout/Layout';
import Section from '../../molecules/Section/Section';
import AlgoliaSearchInput from '../../organisms/AlgoliaSearchInput/AlgoliaSearchInput';
import { breakpoints, unitConverter as uc } from '../../../styles/base';

const SearchPage = ({ data }) => {
  if (!data) {
    return null;
  }

  const sectionCss = css`
    display: flex;
    justify-content: center;
    width: 100%;
    padding: ${uc('150px 50px 50px 50px')};

    @media (${breakpoints.largeTablet}) {
      padding: ${uc('100px 50px 50px 50px')};
    }
  `;
  return (
    <Layout
      menuColor="primary"
      routeName={data.sanitySearchpage.title}
      sanityId={data.sanitySearchpage._id}
    >
      <Section css={sectionCss}>
        <AlgoliaSearchInput
          suggestionLinks={data.sanitySearchpage.suggestionLinks}
        />
      </Section>
    </Layout>
  );
};

SearchPage.propTypes = {
  data: PropTypes.shape({ sanitySearchpage: {} }),
};

SearchPage.defaultProps = {
  data: {},
};

export const query = graphql`
  query($slug: String) {
    sanitySearchpage(route: { slug: { current: { eq: $slug } } }) {
      _id
      title
      suggestionLinks {
        link {
          ... on SanityExternalLink {
            externalLink
            _key
          }
          ... on SanityRoute {
            slug {
              current
            }
            enabled
            _type
          }
        }
        text
      }
    }
  }
`;

export default SearchPage;
